import type { ComparisonType} from "@@/shared/comparisons";
import { comparisonTypes } from "@@/shared/comparisons";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    FeeSourceOrdersConditionId} from "./fee-source-orders-condition-id";
import {
    feeSourceOrdersConditionIdFactory,
    feeSourceOrdersConditionIdZodSchema,
} from "./fee-source-orders-condition-id";

type FeeSourceOrdersConditionCount = {
    readonly _id: FeeSourceOrdersConditionId;
    readonly _type: "FEE_SOURCE_ORDERS_CONDITION";
    readonly type: "COUNT";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly comparison: ComparisonType;
    readonly value: number;
};

type Params = Except<
    FeeSourceOrdersConditionCount,
    "_id" | "type" | "_type" | "_createdAt"
>;
const feeSourceOrdersConditionCountFactory = (
    params: Params,
): FeeSourceOrdersConditionCount => {
    return {
        ...params,
        _id: feeSourceOrdersConditionIdFactory(),
        _type: "FEE_SOURCE_ORDERS_CONDITION",
        _createdAt: nowIsoAndUnix(),
        type: "COUNT",
    };
};

const feeSourceOrdersConditionCountZodSchema: z.ZodSchema<FeeSourceOrdersConditionCount> =
    z.object({
        _id: feeSourceOrdersConditionIdZodSchema,
        _type: z.literal("FEE_SOURCE_ORDERS_CONDITION"),
        type: z.literal("COUNT"),
        _createdAt: isoAndUnixZodSchema,
        comparison: z.enum(comparisonTypes),
        value: z.number(),
    });

export {
    feeSourceOrdersConditionCountFactory,
    feeSourceOrdersConditionCountZodSchema,
};
export type { FeeSourceOrdersConditionCount };
